import React from 'react'
import type { IFormContext } from './interface'

export const FormContext = React.createContext<IFormContext>({} as IFormContext)
